import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { AlertModel } from 'libs/shared/src/lib/models/alert.model';

@Component({
  selector: 'jsg-side-drawer',
  templateUrl: './side-drawer.component.html',
  styleUrls: ['./side-drawer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SideDrawerComponent {
  @Input() alerts: AlertModel[];
  @Input() isOpen: boolean;
}
